<button class="mat-dialog-zavrit-modal">
	<mat-icon>close</mat-icon>
</button>
